/* eslint-disable @typescript-eslint/naming-convention */
import { inject, Injectable } from '@angular/core';
import { UserInfoService } from '../services/user-info.service';
import { Observable } from 'rxjs';
import { USER_MFA_STATUS } from '@xt/domain-model';
import { map } from 'rxjs/operators';
import { Grant, PermissionConfigCriterion } from '@xt/core/permissions';

@Injectable({
  providedIn: 'root',
})
export class RequireMfaStatus implements PermissionConfigCriterion {
  private userInfoService = inject(UserInfoService);

  grants(value: USER_MFA_STATUS): Observable<boolean> {
    return this.userInfoService.userTypeInfo$.pipe(
      map((typeInfo) => typeInfo.mfaStatus === value),
    );
  }

  static readonly VERIFIED = Grant.require(
    RequireMfaStatus,
    USER_MFA_STATUS.VERIFIED,
  );
}
